import React from "react";
import { CardWithActions, LineDivider } from "@/components";
const CardContent = ({ title, children, actions }) => (
  <CardWithActions headerTitle={title} headerActions={actions}>
    <LineDivider />
    {children}
  </CardWithActions>
);
export default CardContent;